import { Auth } from 'aws-amplify';
import ConfirmCode from '@/app/modules/auth/components/confirm-code/confirm-code.vue';

export default {
  name: 'confirm-email',
  components: {
    ConfirmCode,
  },
  data: () => ({
    appName: 'Maestro',
    form: {
      confirmCode: '',
    },
  }),
  methods: {
    async handleConfirmClick(e) {
      if (e === 'cancel' || e === 'submit') {
        if (e === 'submit') {
          await Auth.verifyCurrentUserAttributeSubmit(
            'email',
            this.form.confirmCode,
          );
          this.$store.commit('auth/clearAction');
          this.$store.dispatch('auth/signOut');
        }
        this.$router.push('/auth/sign-in');
      }
    },
  },
};
